import React from "react";
import { Container, Row, Col } from "reactstrap";
import courseImg1 from "../../../assests/images/chemLesson.png";
import courseImg2 from "../../../assests/images/phyLesson.png";
import courseImg3 from "../../../assests/images/freelesson.png";
import "./courses.css";
import CourseCard from "./CourseCard";
import { useNavigate } from "react-router-dom";

const coursesData = [
  {
    id: "01",
    title: "Chemistry Lessons",
    lesson: 12,
    students: 12.5,
    rating: 5.9,
    imgUrl: courseImg1,
    redirectUrl: "/chemistrysection",
  },

  {
    id: "02",
    title: "Physics Lessons",
    lesson: 12,
    students: 12.5,
    rating: 5.9,
    imgUrl: courseImg2,
    redirectUrl: "/physicssection",
  },

  {
    id: "03",
    title: "Free Lessons",
    lesson: 12,
    students: 12.5,
    rating: 5.9,
    imgUrl: courseImg3,
    redirectUrl: "/",
  },
];

const Courses = () => {
  let navigate = useNavigate();

  return (
    <section>
      <Container>
        <Row>
          <Col lg="12" className="mb-5">
            <div className="course__top d-flex justify-content-between align-items-center">
              <div className="course__top__left w-50">
                <h2>Our Class Videos</h2>
                <p>Here you can access our class recordings</p>
              </div>

              <div className="w-50 text-end">
                <button
                  className="w-10 btn"
                  onClick={() =>
                    navigate("/physicssection", {
                      state: { subject: "physics" },
                    })
                  }
                >
                  Physics
                </button>

                <button
                  className="w-20 btn"
                  onClick={() =>
                    navigate("/chemistrysection", {
                      state: { subject: "chemistry" },
                    })
                  }
                >
                  Chemistry
                </button>
              </div>
            </div>
          </Col>
          {coursesData.map((item) => (
            <Col lg="4" md="6" sm="6">
              <CourseCard key={item.id} item={item} navigate={navigate} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Courses;
